import { Component, OnInit, Input } from '@angular/core';
import { DataService } from '../../services/data.service';
import { ModalController, Platform, AlertController } from '@ionic/angular';

@Component({
  selector: 'app-printer-settings',
  templateUrl: './printer-settings.component.html',
  styleUrls: ['./printer-settings.component.scss'],
})
export class PrinterSettingsComponent implements OnInit {

  @Input() is_modal;
  count = 1;
  @Input() setting;
  print_list =[{name:'Normal'},{name:'QZ Tray'}]; 
  print_type = localStorage['print_type'];
  constructor(public db : DataService,public modalCtrl: ModalController) { }

  ngOnInit() {
    this.count = localStorage['no_of_copy'] ? localStorage['no_of_copy'] : 1
  }


  get_value(event){
    if(event.detail.value){
      this.count = event.detail.value;
    }
  }

  value_changed(event){
    // console.log(event.detail.value)
    localStorage['print_type'] = event.detail.value;
  }

  save_button(){
    localStorage['no_of_copy'] = this.count;
    this.db.no_of_copy = localStorage['no_of_copy'];
    this.db.added_animate.next('Saved successfully');
    this.is_modal ? this.modalCtrl.dismiss() : null ;
    // console.log(this.db.no_of_copy)
  }
  
}
